import React from "react";
import { PostTemplate } from "./template/PostTemplate";

const AllPublications = ({ item }) => {
    const data = {
        image: item.publication_cover_img.src,
        title: item.title,
        description: item.summary ?? '....',
        updated_at: item.updated_at,
        url: `/publications/${item.id}` ?? '#'
    };

    return (
        <div>
            <PostTemplate props={data} />
        </div>
    );
}

export default AllPublications;
